import React, { useEffect } from 'react';

const INVOICE_TYPES = [
    { label: 'صورتحساب کاغذی', value: 'Zero_type', icon: 'feather-printer', description: 'حالت اصلی سامانه با همه گزینه‌های فعال' },
    { label: 'نوع اول', value: 'First_type', icon: 'feather-code', description: 'حالت اصلی سامانه با همه گزینه‌های فعال' },
    { label: 'نوع دوم', value: 'Second_type', icon: 'feather-dollar-sign', description: 'دارای محدودیت نوع پرداخت (فقط نقدی)' },
    { label: 'نوع سوم', value: 'Third_type', icon: 'feather-alert-triangle', description: 'دارای محدودیت نوع پرداخت و الگوی چاپی' },
];

const PAYMENT_TYPES = [
    { label: 'نقدی', value: 'cash', icon: 'feather-credit-card', description: 'تسویه کامل در هنگام صدور صورتحساب' },
    { label: 'نسیه', value: 'credit', icon: 'feather-calendar', description: 'تسویه با تاریخ سررسید آتی' },
    { label: 'نقدی / نسیه', value: 'mixed', icon: 'feather-repeat', description: 'ترکیبی از پرداخت نقدی و اعتباری' },
];

function InvoiceTypeStep({ formData, onDataChange, setIsInvoiceTypeDisabled = () => { }, readOnly }) {

    const disablePaymentCondition = ['Paper', 'Second_type', 'Third_type'].includes(formData.invoiceType);

    useEffect(() => {
        const type = formData.invoiceType;
        let disableAlgo = false;
        let disablePayment = false;
        let paymentType;

        if (type === 'Paper') {
            disableAlgo = true;
            disablePayment = true;
            paymentType = 'cash';
        } else if (type === 'Second_type') {
            disablePayment = true;
            paymentType = 'cash';
        } else if (type === 'Third_type') {
            disableAlgo = true;
            disablePayment = true;
            paymentType = 'cash';
        } else {
            disableAlgo = false;
            disablePayment = false;
        }

        setIsInvoiceTypeDisabled({
            algo: disableAlgo,
            payment: disablePayment && (type !== 'First_type'),
        });

        if (disablePayment && formData.paymentType !== paymentType) {
            onDataChange({ paymentType: paymentType });
        }
    }, [formData.invoiceType, setIsInvoiceTypeDisabled, onDataChange, formData.paymentType]);

    const renderCard = (item, isSelected, isItemDisabled, setter, colClass = "col-md-3") => {
        const cardClasses = isSelected
            ? "px-2 py-2 mb-3 d-flex align-items-center justify-content-between border border-primary rounded-1 position-relative cursor-pointer bg-light-primary h-100"
            : isItemDisabled || readOnly
                ? "px-2 py-2 mb-3 d-flex align-items-center justify-content-between border border-dashed border-gray-3 rounded-1 position-relative bg-light text-muted cursor-not-allowed h-100"
                : "px-2 py-2 mb-3 d-flex align-items-center justify-content-between border border-dashed border-gray-3 rounded-1 position-relative cursor-pointer h-100";

        const handleCardClick = () => {
            if (!isItemDisabled && !readOnly) {
                setter(item.value);
            }
        };

        return (
            <div className={`${colClass} mb-3`} key={item.value}>
                <div className={cardClasses} onClick={handleCardClick} style={{ minHeight: '45px' }}>
                    <div className="d-flex align-items-center">
                        <div className="wd-30 d-flex justify-content-center align-items-center flex-shrink-0 me-2">
                            <i className={`${item.icon} fs-20 ${isItemDisabled || readOnly ? 'text-muted' : 'text-primary'}`}></i>
                        </div>

                        <div className="ms-2">
                            <div className={`fw-bold mb-0 fs-13 ${isItemDisabled || readOnly ? 'text-muted' : 'text-dark'}`}>{item.label}</div>
                            {/* <div className="mb-0 text-truncate-1-line fs-10 fw-medium text-uppercase text-muted">
                                {item.description}
                            </div> */}
                        </div>
                    </div>

                    {isSelected && (
                        <div className="position-absolute top-0 start-0 translate-middle mt-1 ms-1">
                            <i className="feather-check fs-10 bg-primary text-white p-1 rounded-circle"></i>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="step-content">
            {/* ۱. نوع صورتحساب */}
            <div className="card-body payment-methord p-0 mb-3">
                <div className="mb-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0">۱. نوع صورتحساب {!readOnly && <span className="text-danger">*</span>}</h6>
                    {/* <div className="text-muted fw-bold">انتخاب فعلی: {INVOICE_TYPES.find(i => i.value === formData.invoiceType)?.label}</div> */}
                </div>

                <div className="row">
                    {INVOICE_TYPES.map(type =>
                        renderCard(
                            type,
                            formData.invoiceType === type.value,
                            false,
                            (value) => onDataChange({ invoiceType: value }),
                            "col-lg-3 col-sm-6 col-12"
                        )
                    )}
                </div>
            </div>

            <hr className="my-3" />

            {/* ۲. نوع پرداخت */}
            <div className="card-body payment-methord p-0 mb-3">
                <div className="mb-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0">۲. نوع پرداخت {!readOnly && <span className="text-danger">*</span>}</h6>
                    {/* <div className="text-muted fw-bold">انتخاب فعلی: {PAYMENT_TYPES.find(t => t.value === formData.paymentType)?.label}</div> */}
                </div>

                <div className="row">
                    {PAYMENT_TYPES.map(type => {
                        const isPaymentDisabled = disablePaymentCondition && type.value !== 'cash';
                        return renderCard(
                            type,
                            formData.paymentType === type.value,
                            isPaymentDisabled,
                            (value) => onDataChange({ paymentType: value }),
                            "col-lg-4 col-sm-6 col-12"
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default InvoiceTypeStep;